import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { useListUserStandards } from '@/shared/hooks/api/userStandards'
import { useSearchParamsNavigate } from '@/shared/hooks/use-search-params-navigate'
import { Header } from '@/components/layout/header'
import { Main } from '@/components/layout/main'
import { ProfileDropdown } from '@/components/profile-dropdown'
import { ThemeSwitch } from '@/components/theme-switch'
import { AddStandardModal } from './components/AddStandardModal'
import { StandardsLibraryPrimaryButtons } from './components/standards-library-primary-buttons'
import { StandardsLibraryTable } from './components/standards-library-table'

export function StandardsLibrary() {
  const { t } = useTranslation('standardsLibrary')
  const { search, navigate } = useSearchParamsNavigate()
  const routerNavigate = useNavigate()
  const { data: standards = [], isLoading } = useListUserStandards()
  const [isAddModalOpen, setIsAddModalOpen] = useState(false)

  if (isLoading) {
    return (
      <>
        <Header fixed>
          <div className='ms-auto flex items-center space-x-4'>
            <ThemeSwitch />
            <ProfileDropdown />
          </div>
        </Header>
        <Main className='flex flex-1 flex-col gap-4 sm:gap-6'>
          <div className='flex items-center justify-center py-12 text-muted-foreground'>
            {t('loading', { ns: 'common' })}
          </div>
        </Main>
      </>
    )
  }

  return (
    <>
      <Header fixed>
        <div className='ms-auto flex items-center space-x-4'>
          <ThemeSwitch />
          <ProfileDropdown />
        </div>
      </Header>

      <Main className='flex flex-1 flex-col gap-4 sm:gap-6'>
        <div className='flex flex-wrap items-end justify-between gap-2'>
          <div>
            <h2 className='text-2xl font-bold tracking-tight'>{t('title')}</h2>
            <p className='text-muted-foreground'>{t('description')}</p>
          </div>
          <StandardsLibraryPrimaryButtons
            onAddStandard={() => setIsAddModalOpen(true)}
          />
        </div>
        <StandardsLibraryTable
          data={standards}
          search={search}
          navigate={navigate}
          onRowClick={(standardId) =>
            routerNavigate(`/standards-library/standards/${standardId}`)
          }
          onAddStandard={() => setIsAddModalOpen(true)}
        />
      </Main>

      <AddStandardModal
        open={isAddModalOpen}
        onOpenChange={setIsAddModalOpen}
        onAdded={(userStandardId) => {
          routerNavigate(`/standards-library/standards/${userStandardId}`)
        }}
      />
    </>
  )
}
